<template>
  <div class="input-field">
    <div v-if="label" class="input-field__label-wrp">
      <span
        class="input-field__label"
        :class="{ error: isShowError && errorMessage }"
      >
        {{ label }}
      </span>
    </div>

    <div
      class="input-field__input-wrp"
      :class="{
        error: isShowError && errorMessage,
        active: isOnInput,
        without_border: !isBorder,
      }"
    >
      <Icon
        class="input-field__input-icon"
        :name="isPasswordType ? 'lock' : 'body'"
      />

      <input
        class="input-field__input"
        :class="{
          error: isShowError && errorMessage,
          'input-field__input-active': isEdit,
        }"
        :type="isPasswordType && !isShowPassword ? 'password' : 'text'"
        v-bind="$attrs"
        :value="modelValue"
        :placeholder="placeholder"
        @focus="isOnInput = true"
        @blur="isOnInput = false"
        @input="onInput"
      />
      <button
        v-if="isPasswordType"
        class="input-field__input-icon-btn"
        :class="{ error: isShowError && errorMessage }"
        type="button"
        @click="isShowPassword = !isShowPassword"
      >
        <Icon
          class="input-field__input-icon"
          :name="isShowPassword ? 'hidePassword' : 'showPassword'"
          :is-error="errorMessage ? isShowError : false"
        />
      </button>
    </div>

    <div v-if="isShowError" class="input-field__error-message-wrp">
      <span class="input-field__error-message">
        {{ errorMessage }}
      </span>
    </div>
  </div>
</template>

<script>
const EVENTS = {
  updateModelValue: 'update:modelValue',
};
import { ref } from 'vue';
import Icon from '@/Vue/common/Icon.vue';

export default {
  components: {
    Icon,
  },
  props: {
    isBorder: { type: Boolean, default: true },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    isPasswordType: { type: Boolean, default: false },
    isSearch: { type: Boolean, default: false },
    modelValue: { type: [String, Number], default: '' },
    errorMessage: { type: String, default: '' },
    isEdit: { type: Boolean, default: false },
  },
  setup(props, context) {
    const isShowPassword = ref(false);
    const isOnInput = ref(false);
    const isShowError = ref(false);

    const onInput = () => {
      isShowError.value = true;
      const value = event.target.value;
      if (props.modelValue === value) return;
      context.emit(EVENTS.updateModelValue, value);
    };

    return { isShowPassword, isOnInput, onInput, isShowError };
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/variables';
@import '../../scss/mixins';

.input-field {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;

  &__error-message {
    font-size: 1.5rem;
    font-weight: 100;
    color: $col-error;
    &-wrp {
      position: absolute;
      top: 6rem;
    }

    @include respond-to($x-small) {
      font-size: 1.2rem;
      &-wrp {
        top: 5rem;
      }
    }
  }

  &__label {
    font-size: 1.5rem;
    font-weight: 100;
    &.error {
      color: $col-error;
    }
    transition: 1ms;
  }

  &__input {
    width: 100%;
    font-weight: 500;
    color: $col-text;

    font-size: 1.8rem;
    height: 2.7rem;
    border: 0;
    padding: 0 1.6rem;

    &::placeholder {
      font-weight: 500;
      color: $col-text;
      font-size: 1.8rem;
    }

    &-wrp {
      display: flex;
      justify-content: space-between;
      border-radius: 1.2rem;
      padding: 0.8rem;

      &.error {
        border-bottom: $input-border-error;
      }

      &.without_border {
        border: 0;
      }
    }

    &:focus {
      &::placeholder {
        color: $col-placeholder;
      }
    }

    &-icon {
      &-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        background: none;
        border: 0;
      }
    }
  }

  &.error {
    &::placeholder {
      color: $col-error;
    }

    &:focus {
      &::placeholder {
        color: $col-placeholder;
      }
    }
  }

  @media (max-width: $tablet) {
    .input-field__input,
    .input-field__label {
      font-size: 1.5rem;
      height: 3rem;
      padding: 0 1rem;

      &::placeholder {
        font-size: 1.5rem;
      }
    }
  }
}
.input-field__input-active {
  border: $pop-up-input-border;
  border-radius: 1.2rem;
}
</style>
